// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h4[data-v-1482344e] {\n  font-weight: 600;\n  color: #37827b;\n}\n.b-card-img[data-v-1482344e] {\n  width: 100%;\n  height: 15vw;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.card[data-v-1482344e] {\n  border: 1px solid black;\n}\n.card-listing[data-v-1482344e] {\n  color: red;\n}\n.no-following-line[data-v-1482344e] {\n  color: red;\n}", ""]);
// Exports
module.exports = exports;
